import RugCardPicture from './RugCardPicture'
export default RugCardPicture
